const actionTypeIdentifier = '39863384-E96F-4FBF-80A4-D3E3E6172A1F';

export const getLocationSiteComments = `DISPUTE-GET-LOCATION-SITE-COMMENTS${actionTypeIdentifier}`;
export const setLocationSiteError = `DISPUTE-SET-LOCATION-SITE-ERROR${actionTypeIdentifier}`;
export const resetLocationSiteComments = `RESET-LOCATION-SITE-COMMENTS${actionTypeIdentifier}`;
export const insertLocationSiteComments = `INSERT-LOCATION-SITE-COMMENTS${actionTypeIdentifier}`;